import { render, staticRenderFns } from "./BatchCategory.vue?vue&type=template&id=428bf973&scoped=true&"
import script from "./BatchCategory.vue?vue&type=script&lang=ts&"
export * from "./BatchCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428bf973",
  null
  
)

export default component.exports